import { render, staticRenderFns } from "./Vehicle_Purchase.vue?vue&type=template&id=2b9f38e8&scoped=true&"
import script from "./Vehicle_Purchase.vue?vue&type=script&lang=js&"
export * from "./Vehicle_Purchase.vue?vue&type=script&lang=js&"
import style0 from "./Vehicle_Purchase.vue?vue&type=style&index=0&id=2b9f38e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9f38e8",
  null
  
)

export default component.exports